<template>
  <div>
    <img class="bg" src="../assets/5.遊戲結束/4_1.分享明信片/遊戲結束後介面_合成明信片_V2.png" />
    <img class="card" v-if="cardUrl" :src="`${host}/${cardUrl}`" />
    <img class="share" src="../assets/5.遊戲結束/4_1.分享明信片/遊戲結束後介面_分享按鈕.png" @click="OnShare" />
    <!--
    <img class="bg" v-show="Player.carType == 1" src="../assets/4.闖關完畢/腳色介面_04-遊戲結束_1.png" />
    <img class="bg" v-show="Player.carType == 2" src="../assets/4.闖關完畢/腳色介面_04-遊戲結束_2.png" />
    <img class="bg" v-show="Player.carType == 3" src="../assets/4.闖關完畢/腳色介面_04-遊戲結束_3.png" />
    <img class="face" v-if="Player.pictureUrl" :src="`${host}/${Player.pictureUrl}`" />
    <img class="car" v-show="Player.carType == 1" src="../assets/4.闖關完畢/HeySong_Car_step03_1.png" />
    <img class="car" v-show="Player.carType == 2" src="../assets/4.闖關完畢/HeySong_Car_step03_2.png" />
    <img class="car" v-show="Player.carType == 3" src="../assets/4.闖關完畢/HeySong_Car_step03_3.png" />
    <img class="result" src="../assets/4.闖關完畢/腳色介面_恭喜過關字.png" />
    <div class="timecontainer">
      <p class="time">{{ this.score }}</p>
    </div>
    <img class="sharebg" src="../assets/4.闖關完畢/分享明信片_文字.png" />
    <img class="share" src="../assets/5.遊戲結束/4_1.分享明信片/遊戲結束後介面_分享按鈕.png" @click="OnShare" />
    -->
  </div>
</template>
<script>
export default {
  props: {
    Player: {
      id: ""
    },
    OnCountdownEnded: {
      type: Function
    }
  },
  data() {
    return {
      host: "",
      score: 0,
      cardUrl: null
    };
  },
  mounted() {
    this.host = process.env.VUE_APP_BASEURL;
  },
  methods: {
    async OnShare() {
      if (this.OnCountdownEnded) {
        this.OnCountdownEnded();
      }
    },
    async Countdown(score, cardUrl) {
      this.score = score;
      this.cardUrl = cardUrl;
      this.Player.score = score;
    },
    Delay(interval) {
      return new Promise(resolve => {
        setTimeout(resolve, interval);
      });
    }
  }
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  max-width: 100vw;
}
.car {
  position: absolute;
  left: 0vw;
  top: 70vw;
  width: 100vw;
  z-index: 3;
}
.card {
  position: absolute;
  left: 3.33vw;
  top: 49.6vw;
  width: 93.6vw;
  z-index: 3;
}
.result {
  position: absolute;
  left: -6vw;
  top: 11vw;
  width: 80vw;
  z-index: 1;
}
.face {
  position: absolute;
  left: 41vw;
  top: 97vw;
  width: 18vw;
  z-index: 2;
}
.share {
  position: absolute;
  left: 29.5vw;
  top: 142vw;
  width: 41vw;
  z-index: 5;
}
.sharebg {
  position: absolute;
  left: 0vw;
  top: 136vw;
  width: 100vw;
  z-index: 4;
}
.timecontainer {
  position: absolute;
  left: 36vw;
  top: 35vw;
  text-align: center;
  width: 15vw;
  max-width: 15vw;
  height: 10vw;
}
.time {
  position: relative;
  color: white;
  font-size: 10vw;
  margin: 0;
  z-index: 1;
}
</style>
